import React, { useCallback, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useRef, useState } from 'react';
import PwChangePopup from '../pages/System/Popup/PWChangePopup';
import FavoritePopup from '../pages/System/Popup/FavoritePopup';
import AlarmPopup from '../pages/System/Popup/AlarmPopup';
import { PAGE_RENDER_TYPE } from '@maxis/client-logic/constants/enumerates';
import styles from './_topMenu.module.css';
// import styles from './TopMenu.module.css';
import useFetch from '@maxis/client-logic/hooks/useFetch';
import useAuth from '@maxis/client-logic/hooks/useAuth';
import { toggleFullScreen } from '@maxis/client-logic/utils/uiUtil';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { LOCAL_STORAGE_KEYS } from '@maxis/client-logic/constants/enumerates';
import { setLocalStorageItem } from '@maxis/client-logic/utils/localStorageUtil';
import useTabMenu from '@maxis/client-logic/hooks/useTabMenu';
import { shallow } from 'zustand/shallow';
import { HOME_MENU_ID } from '@maxis/client-logic/constants/constMenuId';
import { THEME } from '@maxis/client-logic/constants/common';
import _ from 'lodash';
import { GrAnnounce, GrCircleQuestion } from 'react-icons/gr';

const BOARD_NOTICE_MENU_ID = 'BOARD_001_LIST';
const BOARD_FAQ_MENU_ID = 'BOARD_002_LIST';
const BOARD_REF_MENU_ID = 'BOARD_003_LIST';

const TopMenu = ({ setAiOpen }) => {
    const { logout } = useAuth();
    const { request } = useFetch();
    const { changeTab } = useTabMenu();
    const iconRef = useRef();
    const [sseData, setSseData] = useState([]);
    const [alarmData, setAlarmData] = useState([]);
    const [activeActionMenu, setActiveActionMenu] = useState(null);

    const navigate = useNavigate();
    const menuList = useBoundStore((state) => state.menu.menuList);

    const {
        user,
        hierarchyMenu,
        pageRenderType,
        showTopMenuYn,
        selectedTopMenu,
        setSelectedTopMenu,
        setSelectedMenu,
    } = useBoundStore(
        (state) => ({
            user: state.user,
            hierarchyMenu: state.menu.hierarchyMenu,
            pageRenderType: state.menu.pageRenderType,
            showTopMenuYn: state.menu.showTopMenuYn,
            selectedTopMenu: state.menu.selectedTopMenu,
            setSelectedTopMenu: state.menu.setSelectedTopMenu,
            setSelectedMenu: state.menu.setSelectedMenu,
            helpMenuYn: state.menu.helpMenuYn,
        }),
        shallow
    );

    const [fullScreenMode, setFullScreenMode] = useState(false);

    const controls = {
        pwChangePopup: useRef(),
        FavoritePopup: useRef(),
        AlarmPopup: useRef(),
    };

    const eventHandler = {
        button: {
            onLoginClick: () => {
                navigate(import.meta.env.VITE_PUBLIC_URL + '/login');
            },
            onLogoutClick: async () => {
                logout(user?.userId);
            },
            onFullScreenClick: () => {
                if (toggleFullScreen() === true) {
                    setFullScreenMode(true);
                } else {
                    setFullScreenMode(false);
                }
            },
            onLightClick: (color) => {
                const style = 'light ' + color;

                eventHandler.themeChg(style);
                document.body.classList = [style];
            },
            onDarkClick: (color) => {
                const style = 'dark ' + color;

                eventHandler.themeChg(style);
                document.body.classList = [style];
            },
            onAIClick: () => setAiOpen((prev) => !prev),
        },
        onMenuClick: (m) => {
            if (!m) {
                setSelectedTopMenu({
                    menuId: '',
                    menuName: '',
                    sideYn: 'N',
                    displayYn: 'N',
                    menuNameListId: '',
                    menuNameList: '',
                });
                return;
            }

            setSelectedTopMenu({
                menuId: m.menuId,
                menuName: m.menuName,
                sideYn: m.sideYn,
                displayYn: m.displayYn,
                menuNameListId: m.menuNameListId,
                menuNameList: m.menuNameList,
            });
            if (pageRenderType === PAGE_RENDER_TYPE.PAGE && m.programRoutePath) {
                navigate(import.meta.env.VITE_PUBLIC_URL + m.programRoutePath);
                return;
            }
        },
        setHome: (m) => {
            // 그리드 개인화 기능을 위한 메뉴ID 인식
            setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, m);

            setSelectedMenu({
                menuId: m,
                menuName: 'home',
                sideYn: 'Y',
                displayYn: 'Y',
                menuNameList: 'home',
                menuNameListId: m,
            });

            changeTab(m);
        },
        themeChg: (color) => {
            if (user?.userId) {
                const param = { USER_ID: user?.userId, PROP_STR1: color };
                request(
                    `/E3/SYSTEM/ChangeTheme`,
                    { method: 'POST', body: param },
                    { showConfirm: false }
                );
            }
        },
        onShowPopup: {
            pwChange: () => {
                controls.pwChangePopup.current?.showPopup();
            },
            favorite: () => {
                controls.FavoritePopup.current?.openPopup(menuList);
            },
            alarm: () => {
                const rect = iconRef.current.getBoundingClientRect();

                const position = {
                    left: rect.left + window.scrollX,
                    top: rect.top + rect.height + window.scrollY,
                };
                afterProcessing();
                controls.AlarmPopup.current?.openPopup(alarmData.length ?? 0, position);
            },
        },
        sse: {
            afterProcessing: (data, e) => {
                request(
                    `/E3/SYSTEM/GetAlarmList`,
                    { method: 'POST', body: param },
                    { showConfirm: false, showLoad: false }
                );
            },
            updateReadYn: (e) => {
                const response = request(
                    `/E3/SYSTEM/UpdateReadYn`,
                    { method: 'POST', body: { READ_YN: 'Y' } },
                    { showConfirm: false, showLoad: false }
                );
                if (response) {
                    afterProcessing();
                }
            },
        },
        link: {
            move: (MENU_ID) => {
                
                setSelectedMenu({
                    menuId: MENU_ID,
                    menuName: '',
                    sideYn: 'N',
                    displayYn: 'N',
                    menuNameList: '',
                    menuNameListId: MENU_ID,
                });

                changeTab(MENU_ID);
            },
        },
    };

    const afterProcessing = async () => {
        const result = await request(
            `/E3/SYSTEM/GetAlarmList`,
            { method: 'POST', body: {} },
            { showConfirm: false, showLoad: false }
        );
        if (result) {
            controls.AlarmPopup.current?.bindingGrid(result, () => setAlarmData(result));
        }
    };

    useEffect(() => {
        afterProcessing();
    }, [sseData]);

    useEffect(() => {
        const closeActionMenu = () => setActiveActionMenu(null);

        document.addEventListener('click', closeActionMenu);
        return () => document.removeEventListener('click', closeActionMenu);
    }, []);

    const toggleActionMenu = (event, menuName) => {
        event.stopPropagation();
        setActiveActionMenu((current) => (current === menuName ? null : menuName));
    };

    const closeActionMenu = () => setActiveActionMenu(null);

    return (
        // <!-- header -->
        <div className={styles.header}>
            <div className={styles.headerWeb}>
                <div className={styles.headerLogo}>
                    <Link
                        to={import.meta.env.VITE_PUBLIC_URL + '/'}
                        // onClick={() => eventHandler.setHome(HOME_MENU_ID)}
                    >
                        <img
                            src={
                                import.meta.env.VITE_PUBLIC_URL +
                                '/assets/images/logo/maxis/maxis_logo_login.png'
                            }
                            alt="Logo"
                        />
                    </Link>
                </div>
                <div className={styles.actions}>
                    <button
                        type="button"
                        aria-label="공지사항 메뉴"
                        className={activeActionMenu === 'notice' ? styles.actionMenuOpen : ''}
                        onClick={(event) => toggleActionMenu(event, 'notice')}
                    >
                        <span
                            className={`${styles.bbs_icon} ${styles.bbs_icon_gr}`}
                            aria-hidden
                        >
                            <GrAnnounce />
                        </span>
                        <div className={styles.bbs} onClick={(event) => event.stopPropagation()}>
                            <ul className={styles.bbs_list}>
                                <li
                                    onClick={() => {
                                        closeActionMenu();
                                        eventHandler.link.move(BOARD_NOTICE_MENU_ID);
                                    }}
                                >
                                    공지사항
                                </li>
                            </ul>
                        </div>
                    </button>
                    <button
                        type="button"
                        aria-label="Q&A·자료실·오픈소스 메뉴"
                        className={activeActionMenu === 'board' ? styles.actionMenuOpen : ''}
                        onClick={(event) => toggleActionMenu(event, 'board')}
                    >
                        <span
                            className={`${styles.bbs_icon} ${styles.bbs_icon_gr}`}
                            aria-hidden
                        >
                            <GrCircleQuestion />
                        </span>
                        <div className={styles.bbs} onClick={(event) => event.stopPropagation()}>
                            <ul className={styles.bbs_list}>
                                <li
                                    onClick={() => {
                                        closeActionMenu();
                                        eventHandler.link.move(BOARD_FAQ_MENU_ID);
                                    }}
                                >
                                    Q&A
                                </li>
                                <li
                                    onClick={() => {
                                        closeActionMenu();
                                        eventHandler.link.move(BOARD_REF_MENU_ID);
                                    }}
                                >
                                    자료실
                                </li>
                                <li
                                    onClick={() => {
                                        closeActionMenu();
                                        navigate(import.meta.env.VITE_PUBLIC_URL + '/licenses')
                                    }}
                                >
                                    오픈소스
                                </li>
                            </ul>
                        </div>
                    </button>
                    <button type="button" onClick={eventHandler.onShowPopup.pwChange}>
                        <i translate="no">person_edit</i>
                        <div>내 정보</div>
                    </button>
                    <button
                        type="button"
                        className={styles.actionIconThin}
                        onClick={eventHandler.button.onLogoutClick}
                    >
                        <i translate="no">logout</i>
                        <div>로그아웃</div>
                    </button>
                    <button
                        type="button"
                        className={styles.actionIconThin}
                        onClick={eventHandler.button.onFullScreenClick}
                    >
                        <i translate="no">{fullScreenMode ? 'fullscreen_exit' : 'fullscreen'}</i>
                        <div>{fullScreenMode ? '전체화면 해제' : '전체화면'}</div>
                    </button>
                    {/* <button onClick={eventHandler.button.onAIClick}>
                        <i translate="no">auto_awesome</i>
                        <p>Agent</p>
                    </button> */}
                </div>
                {/* <div className={styles.headerLogo}>
                    <Link
                        to={import.meta.env.VITE_PUBLIC_URL + '/'}
                        onClick={() => eventHandler.setHome(HOME_MENU_ID)}
                    >
                        <img
                            src={
                                import.meta.env.VITE_PUBLIC_URL +
                                '/assets/images/logo/insighton/SK.png'
                            }
                            alt="Logo"
                        />
                    </Link>
                </div> */}
                {/* <div className={styles.headerGnb}>
                    {showTopMenuYn === 'Y' ? (
                        <ul>
                            {hierarchyMenu.map((m) => (
                                <li key={m.menuId} onClick={() => eventHandler.onMenuClick(m)}>
                                    <div
                                        className={
                                            selectedTopMenu?.menuId === m.menuId
                                                ? styles.selected
                                                : ''
                                        }
                                    >
                                        {m.menuName}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </div> */}
                {/* 
                1. 비밀번호 변경
                2. 알람
                3. 즐겨찾기
                4. Thema
                5. Logout
                6. AI Chatbot
                 */}
                {/* <div className={styles.actions}> */}
                {/* <button className={styles.item}></button> */}
                {/* <div>sad</div> */}
                {/* <div className={styles.headerUserInfo}> */}
                {/* 로그아웃 : 로그인 정보 있을때 */}
                {/* {user?.userId && (
                            <>
                                <span className={styles.headerPersonPhoto}></span>
                                <span
                                    className={styles.headerPerson}
                                    onClick={eventHandler.onShowPopup.pwChange}
                                >
                                    {user?.userNm} ({user?.userId})
                                    <em className={styles.tooltip}>비밀번호 변경</em>
                                </span>{' '}
                                님
                            </>
                        )} */}
                {/* 로그인 : 로그인 정보 없을 때 */}
                {/* {!user?.userId && (
                            <button
                                className={`btn ${styles.headerLogin}`}
                                onClick={eventHandler.button.onLoginClick}
                            >
                                로그인
                            </button>
                        )} */}
                {/* </div> */}
                {/* <div
                        className={styles.divAlarm}
                        onClick={eventHandler.onShowPopup.alarm}
                        ref={iconRef}
                    >
                        {alarmData?.length ? (
                            <span>{alarmData?.length > 99 ? '99+' : alarmData?.length}</span>
                        ) : null}
                        <em className={styles.tooltip}>My Alarm</em>
                    </div> */}
                {/* <button
                        className={styles.btnFavorite}
                        onClick={eventHandler.onShowPopup.favorite}
                    >
                        <em className={styles.tooltip}>My Favorite</em>
                    </button> */}
                {/* <div className={styles.colormode}>
                        <a href="#" className={`${styles.colorLink} material-symbols-outlined`}>
                            water_drop
                        </a>
                        <div>
                            <h3>Type</h3>
                            <ul>
                                <li>
                                    <a
                                        onClick={() => eventHandler.button.onLightClick(THEME.RED)}
                                        className={`${styles.subcolorLink} material-symbols-outlined red`}
                                    >
                                        humidity_high
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={() =>
                                            eventHandler.button.onLightClick(THEME.ORANGE)
                                        }
                                        className={`${styles.subcolorLink} material-symbols-outlined orange`}
                                    >
                                        humidity_high
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={() => eventHandler.button.onLightClick(THEME.BLUE)}
                                        className={`${styles.subcolorLink} material-symbols-outlined blue`}
                                    >
                                        humidity_high
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={() =>
                                            eventHandler.button.onLightClick(THEME.GREEN)
                                        }
                                        className={`${styles.subcolorLink} material-symbols-outlined green`}
                                    >
                                        humidity_high
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> */}

                {/* <button
                        className={styles.btnLogout}
                        onClick={eventHandler.button.onLogoutClick}
                    >
                        <em className={styles.tooltip}>Logout</em>
                    </button> */}

                {/* <div className={styles.fullscreenIcon}>
                        {fullScreenMode === false ? (
                            <button
                                className={styles.iconFullscreen}
                                onClick={eventHandler.button.onFullScreenClick}
                            >
                                <em className={styles.tooltip}>Full Screen</em>
                            </button>
                        ) : (
                            <button
                                className={styles.iconOriginalscreen}
                                onClick={eventHandler.button.onFullScreenClick}
                            >
                                <em className={styles.tooltip}>Origin Screen</em>
                            </button>
                        )}
                    </div> */}

                {/* <button
                        className={`${styles.btnAichat} material-symbols-outlined`}
                        onClick={() => setAiOpen((prev) => !prev)}
                    >
                        smart_toy
                    </button> */}
                {/* </div> */}
            </div>

            <PwChangePopup ref={controls.pwChangePopup} />
            <FavoritePopup ref={controls.FavoritePopup} />
            <AlarmPopup
                ref={controls.AlarmPopup}
                callBackAction={(e) => setSseData(e)}
                updateCallBack={(e) => eventHandler.sse.updateReadYn(e)}
            />
        </div>
    );
};

TopMenu.displayName = 'TopMenu';
export default TopMenu;
